// ========================================
// ================== V3 ==================
// ========================================

import { put } from "redux-saga/effects";
import axios from "../../axios";
import * as actions from "../actions/index";
import * as kApi from "../../constants/api";
import { Auth } from "aws-amplify";
import { refreshTokenSaga } from "./_LocalRefreshToken";

export function* initFetchProductsSaga(action) {
  try {
    const response = yield axios.get(kApi.API_URL_PRODUCTS, {
      headers: {
        Authorization: Auth.user.signInUserSession.idToken.jwtToken,
      },
    });

    yield put(actions.fetchPlansSuccess(response.data));
  } catch (error) {
    try {
      const refreshToken = yield refreshTokenSaga();
      const response = yield axios.get(kApi.API_URL_PRODUCTS, {
        headers: {
          Authorization: refreshToken.signInUserSession.idToken.jwtToken,
        },
      });

      yield put(actions.fetchPlansSuccess(response.data));
    } catch (error) {
      yield put(actions.fetchPlansFail(error));
    }
  }
}

// Auth.currentAuthenticatedUser()
//   .then(user => {
//     const token = user.signInUserSession.idToken.jwtToken;
//     fetch(kApi.API_URL_SALES_UPDATES, {
//       method: "GET",
//       headers: {
//         Authorization: token,
//       }
//     })
//       .then(response => response.json())
//       .then(data => {
//         console.log("Dados da API:", data);
//         console.log("Dados da API00000000:", token);
//         console.log("JSON string:", JSON.stringify(data, null, 2));
//       })
//       .catch(error => {
//         console.error("Erro ao buscar dados:", error);
//       });
//   })
//   .catch(error => {
//     // Usuário não autenticado!
//     console.error("Usuário não autenticado:", error);
//   });